import React from "react";
import Banner, {bannerStyle} from "@components/Banner";
import MegaphoneIcon from "../../../icons/MegaphoneIcon";

interface BannerGMProps {
    }

const BannerGM: React.FC<BannerGMProps> = () => {

    return <>
        <div className="w-full text-xs md:text-sm rounded-lg bg-yellow-100">
            <Banner style={bannerStyle.warning} className="m-0 border rounded-lg border-yellow-400 text-yellow-800">
                <MegaphoneIcon className="h-7 w-7"/>
                <div className="ml-3">
                    <span><strong>Giustificazione di massa AVVIATA.</strong> Per selezionare le giornate da giustificare:</span>
                    <ul className="list-decimal ml-6">
                        <li>
                            <span><strong>Click</strong> sulla giornata iniziale e <strong>SHIFT Click</strong> sulla giornata finale, per selezionare un intervallo.</span>
                        </li>
                        <li>
                            <span><strong>CTRL + Click</strong> per selezionare o deselezionare un singolo giorno (<strong>Cmd + Click</strong> su MacOS).</span>
                        </li>
                        <li>
                            <span>Clicca sul bottone <strong>"Applica GM"</strong> per procedere.</span>
                        </li>
                    </ul>
                </div>
            </Banner>
        </div>
    </>
}

export default BannerGM;